import Api from "lib/api/httpRequestHelper";

const VALID_ORIGINS = new Set([
  "home",
  "lojista-360",
  "acompanhamento-titulos",
  "encontro-contas",
]);

function triggerFileDownload(blob, filename) {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(blobUrl);
}

export default async function downloadBoleto(origem, numeroTitulo) {
  const origin = origem != null ? String(origem).trim() : "";
  const numero = numeroTitulo != null ? String(numeroTitulo).trim() : "";

  if (!VALID_ORIGINS.has(origin) || !numero) {
    throw new Error("Parâmetros inválidos para download do boleto.");
  }

  const params = `?origem=${encodeURIComponent(origin)}&numeroTitulo=${encodeURIComponent(numero)}`;
  const blob = await Api.getBlob("download-boleto", "financialdocument", params, true);

  triggerFileDownload(blob, `boleto-${numero}.pdf`);
}
